import { render, staticRenderFns } from "./PricesCreate.vue?vue&type=template&id=3f2b93ac"
import script from "./PricesCreate.vue?vue&type=script&lang=js"
export * from "./PricesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports